module.exports = __webpack_public_path__ + "img/P_FAQ04.3c307322.png";